"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var react_scroll_to_top_1 = __importDefault(require("react-scroll-to-top"));
var Scrool = function () {
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement(react_scroll_to_top_1.default, { smooth: true, viewBox: "0 0 24 24", svgPath: "m12 6.586-8.707 8.707 1.414 1.414L12 9.414l7.293 7.293 1.414-1.414L12 6.586z" })));
};
exports.default = Scrool;
